import React from "react";
import { education } from "../constants";

const Education = () => {
  return (
    <section
      id="education"
      className="py-28 px-[6vw] md:px-[8vw] lg:px-[15vw] relative bg-gradient-to-b from-[#050414] via-[#09051f] to-[#050414]"
    >
      {/* Section Title */}
      <div className="text-center max-w-3xl mx-auto mb-20 space-y-4">
        <h2 className="text-xs uppercase tracking-[0.3em] font-bold text-[#8245ec]">Academic Background</h2>
        <h3 className="text-3xl sm:text-5xl font-extrabold text-white tracking-tight">Education & Credentials</h3>
        <div className="w-24 h-1.5 bg-gradient-to-r from-[#8245ec] to-purple-400 mx-auto rounded-full"></div>
        <p className="text-gray-400 text-base sm:text-lg">
          My academic foundation in Computer Science & Engineering combined with practical technical milestones.
        </p>
      </div>

      {/* Timeline Container */}
      <div className="relative max-w-4xl mx-auto">
        {/* Center Line */}
        <div className="absolute left-4 sm:left-1/2 transform sm:-translate-x-1/2 w-1 bg-gradient-to-b from-[#8245ec] via-purple-500 to-transparent h-full rounded-full"></div>

        {education.map((edu, index) => (
          <div
            key={edu.id}
            className={`flex flex-col sm:flex-row items-center mb-16 relative ${
              index % 2 === 0 ? "sm:justify-start" : "sm:justify-end"
            }`}
          >
            {/* Timeline Marker Circle */}
            <div className="absolute left-4 sm:left-1/2 transform -translate-x-1/2 bg-[#050414] border-4 border-[#8245ec] w-10 h-10 rounded-full flex justify-center items-center z-10 shadow-[0_0_15px_rgba(130,69,236,0.8)]">
              <div className="w-3 h-3 bg-purple-400 rounded-full animate-pulse"></div>
            </div>

            {/* Content Card */}
            <div
              className={`w-full sm:w-[45%] ml-12 sm:ml-0 bg-white/[0.02] border border-white/10 p-6 sm:p-8 rounded-3xl backdrop-blur-xl shadow-xl hover:border-purple-500/50 hover:shadow-[0_0_30px_rgba(130,69,236,0.15)] transition-all duration-300`}
            >
              <div className="flex items-center space-x-4 mb-4">
                <div className="w-14 h-14 bg-white/10 rounded-xl overflow-hidden border border-white/10 flex-shrink-0">
                  <img
                    src={edu.img}
                    alt={edu.school}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h4 className="text-lg sm:text-xl font-bold text-white leading-snug">{edu.degree}</h4>
                  <p className="text-sm font-medium text-purple-400">{edu.school}</p>
                </div>
              </div>

              <div className="flex justify-between items-center text-xs font-mono text-gray-400 py-2 border-y border-white/10 my-4">
                <span>{edu.date}</span>
              </div>

              <p className="text-gray-400 text-sm leading-relaxed">{edu.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Education;